import type { JSX } from 'react';
import type { CdsFinding } from '@ampshift/shared';

export function CdsFindingView({ finding, children }: { finding: CdsFinding; children?: React.ReactNode }): JSX.Element {
  return (
    <li className={`cds cds-${finding.severity}`}>
      <div className="cds-head">
        <span className="cds-severity">{finding.severity.toUpperCase()}</span>
        <strong>{finding.summary}</strong>
      </div>
      {finding.detail ? <p className="small">{finding.detail}</p> : null}
      <p className="muted small">
        {finding.source.label}
        {finding.source.validated ? '' : ' (not yet clinically validated for this clinic)'} · {finding.ruleId}
      </p>
      {finding.suggestions.length > 0 ? (
        <ul className="cds-suggestions small">
          {finding.suggestions.map((s, i) => (
            <li key={i}>{s.label}</li>
          ))}
        </ul>
      ) : null}
      {children}
    </li>
  );
}
